import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async switchAnnotation(counterpointID, roundCounterpointID, annotationID, annotationData) {
    return await picador.put(
      'switchAnnotation',
      xhrPath.counterpoint({ counterpointID, roundCounterpointID, annotationID }) + '/switch',
      annotationData
    );
  },

  async deleteTeamReply(counterpointID, roundCounterpointID, annotationID) {
    return await picador.delete(
      'deleteTeamReply',
      xhrPath.counterpoint({ counterpointID, roundCounterpointID, annotationID })
    );
  },

  async addHostInlineRule(counterpointID, roundsIDs, ruleModel) {
    return await picador.post(
      'addHostInlineRule',
      xhrPath.counterpoint({ counterpointID }) + '/hostInstruction',
      {
        rounds: roundsIDs,
        ruleModel,
      }
    );
  },

  async deleteHostInlineRule(
    counterpointID,
    annotationRoundId,
    refByAnnotationRoundId,
    annotation,
    refByAnnotation
  ) {
    return await picador.delete(
      'deleteHostInlineRule',
      xhrPath.counterpoint({ counterpointID }) + '/hostInstruction',
      {
        params: {
          annotationRoundId,
          refByAnnotationRoundId,
          annotation,
          refByAnnotation,
        },
      }
    );
  },

  async submitHostInstructions(counterpointID, organization, document) {
    return await picador.post(
      'submitHostInstructions',
      xhrPath.counterpoint({ counterpointID }) + '/submit-hostInstructions',
      {
        organization,
        document,
      }
    );
  },
};
